// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 647 ? "second" : chunkId) + "." + {"647":"87edecd5","850":"9ca7e7d3"}[chunkId] + ".css";
};